














import moment from 'moment';
import { Vue, Component } from 'vue-property-decorator';
import ContractSummary from '@/domain/contract/entity/contract-summary.entity';
import { VbSnackbarService } from '@/shared/snackbar/snackbar.service';
import UserBusinessUnitService from '@/domain/business-unit/service/business-unit.store';
import EventBus, { Event } from '@/event.bus';
import BusinessUnit from '@/domain/business-unit/entity/business-unit.entity';
import InstanceService from '@/domain/contract/service/instance.service';
import InstanceSummary from '@/domain/contract/entity/instances-summary.entity';
import OverviewMainCard from './overview-main-card.component.vue';
import ContractService from '../../domain/contract/service/contract.service';
import BillingService from '../../domain/billing/service/billing.service';
import Summary from '../../domain/billing/entity/summary.entity';

@Component({
  components: {
    OverviewMainCard,
  },
})
export default class Overview extends Vue {
  private contractSummary: ContractSummary = ContractSummary.of({});

  private summary: Summary = Summary.of({});

  private businessUnitId: string = '';

  fetchedAt: String = '';

  private instanceSummary: InstanceSummary = new InstanceSummary();

  private get pastMonth(): string {
    const date: Date = new Date();
    date.setDate(1);
    date.setMonth(date.getMonth() - 1);
    return new Date(date).toISOString().substring(0, 7);
  }

  private competenceMonth: string = this.pastMonth;

  private updateCompetenceMonth(value: string): void {
    const newCompetenceMonth: string = value !== '' ? new Date(value).toISOString().substring(0, 7) : '';
    this.competenceMonth = newCompetenceMonth;
    this.getContractSummary();
    this.getBillingSummary();
    this.getInstanceSummary(this.businessUnitId, this.competenceMonth);
  }

  private getContractSummary(): void {
    ContractService.getContractsSummary(this.businessUnitId, this.competenceMonth)
      .then((response: any) => {
        this.contractSummary = response;
      }).catch(VbSnackbarService.handleHttpError);
  }

  private getBillingSummary(): void {
    BillingService.getBillingSummary(this.businessUnitId, this.competenceMonth)
      .then((response: any) => {
        this.summary = response;
      })
      .catch(VbSnackbarService.handleHttpError);
  }

  private fetchInfo(): void {
    if (this.businessUnitId) {
      const localStorageKey = `summary:${this.businessUnitId}`;
      if (this.competenceMonth === this.pastMonth) {
        const storedStringJson = localStorage.getItem(localStorageKey);
        if (storedStringJson !== null) {
          const storedObject = JSON.parse(storedStringJson);
          const fetchedAt = moment(storedObject.fetchedAt);
          if (moment().diff(fetchedAt, 'minutes') < 5) {
            this.fetchedAt = fetchedAt.format();
            this.contractSummary = storedObject.contractSummary;
            this.summary = storedObject.billingSummary;
            this.instanceSummary = storedObject.instanceSummary;
            return;
          }
        }
      }

      const contractsSummaryPromise = ContractService.getContractsSummary(
        this.businessUnitId,
        this.competenceMonth,
      );
      const billingSummaryPromise = BillingService.getBillingSummary(
        this.businessUnitId,
        this.competenceMonth,
      );
      const instanceSummaryPromise = InstanceService.getInstanceSummary(
        this.businessUnitId,
        this.competenceMonth,
      );
      Promise.all([contractsSummaryPromise, billingSummaryPromise, instanceSummaryPromise])
        .then(([contractSummaryResponse, billingSummaryResponse, instanceSummaryResponse]) => {
          this.contractSummary = contractSummaryResponse;
          this.summary = billingSummaryResponse;
          this.instanceSummary = instanceSummaryResponse;
          if (this.competenceMonth === this.pastMonth) {
            this.fetchedAt = moment().format();
            const localStorageObject = {
              fetchedAt: this.fetchedAt,
              contractSummary: this.contractSummary,
              billingSummary: this.summary,
              instanceSummary: this.instanceSummary,
            };
            localStorage.setItem(localStorageKey, JSON.stringify(localStorageObject));
          }
        })
        .catch(VbSnackbarService.handleHttpError)
    }
  }

  forceSummaryUpdate(): void {
    localStorage.removeItem(`summary:${this.businessUnitId}`);
    this.fetchInfo();
  }

  created() {
    this.businessUnitId = UserBusinessUnitService.currentBusinessUnit.id;
    if (this.businessUnitId) {
      EventBus.$off(Event.BUSINESS_UNIT_SELECTED);
    }
    EventBus.$on(Event.BUSINESS_UNIT_SELECTED, (businessUnit: BusinessUnit) => {
      if (this.$route.name && this.$route.name.includes('Visão Geral')) {
        this.businessUnitId = businessUnit.id;
        this.fetchInfo();
      }
    });
    this.fetchInfo();
  }

  getInstanceSummary(businessUnitId: string, compentence: string) {
    InstanceService.getInstanceSummary(businessUnitId, compentence)
      .then((response: InstanceSummary) => {
        this.instanceSummary = new InstanceSummary(response);
      }).catch((error) => VbSnackbarService.handleHttpError(error))
  }
}
